<app-content-header [hideBreadcrumb]="true" [class]="'py-3'" [hasBgImage]="true"
    [target]="'subjectsTeachersList'"></app-content-header>

<div class="hide_print">
    <mat-card>
        <mat-form-field fxFlex="25" class="pr-2 pl-2">
            <mat-select [placeholder]="translate.instant('sector')" [(ngModel)]="selectedSector"
                (selectionChange)="changeSector()">
                <mat-option *ngFor="let sector of sectors" [value]="sector.id">
                    {{sector.abbreviation}}</mat-option>
            </mat-select>
        </mat-form-field>

        <div fxFlex="75">
            <button mat-raised-button color="basic" class="ums_basic_button" [style.float]="'inverse_float' | translate"
                (click)="print()">
                <mat-icon class="fs20">print</mat-icon> {{'buttons.print' | translate}}
            </button>
        </div>
    </mat-card>
</div>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<div id="print_subject_teachers">
    <mat-card>
        <mat-card-content>
            <div *ngIf="(reportSem1.length + reportSem2.length + reportOther.length) > 0; else no_data">
                <div class="sem-title">Semestre 1</div>
                <div *ngIf="reportSem1.length === 0" class="empty-sem">Aucune donnée</div>
                <div class="mat-elevation-z8" *ngIf="reportSem1.length > 0">
                    <table mat-table style="width:100%" [dataSource]="dataSourceSem1">
                        <ng-container matColumnDef="subject">
                            <th mat-header-cell *matHeaderCellDef> {{'subject' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.subject}} </td>
                        </ng-container>
                        <ng-container matColumnDef="teacher">
                            <th mat-header-cell *matHeaderCellDef> {{'teacher' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.teacher}} </td>
                        </ng-container>
                        <ng-container matColumnDef="subject_type">
                            <th mat-header-cell *matHeaderCellDef> {{'subject_type' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.subject_type}} </td>
                        </ng-container>
                        <ng-container matColumnDef="nb_hours">
                            <th mat-header-cell *matHeaderCellDef> {{'nb_hours' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.nb_hours}} </td>
                        </ng-container>
                        <ng-container matColumnDef="groups">
                            <th mat-header-cell *matHeaderCellDef> {{'groups' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.groups}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>

                <div class="sem-title sem-break">Semestre 2</div>
                <div *ngIf="reportSem2.length === 0" class="empty-sem">Aucune donnée</div>
                <div class="mat-elevation-z8" *ngIf="reportSem2.length > 0">
                    <table mat-table style="width:100%" [dataSource]="dataSourceSem2">
                        <ng-container matColumnDef="subject">
                            <th mat-header-cell *matHeaderCellDef> {{'subject' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.subject}} </td>
                        </ng-container>
                        <ng-container matColumnDef="teacher">
                            <th mat-header-cell *matHeaderCellDef> {{'teacher' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.teacher}} </td>
                        </ng-container>
                        <ng-container matColumnDef="subject_type">
                            <th mat-header-cell *matHeaderCellDef> {{'subject_type' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.subject_type}} </td>
                        </ng-container>
                        <ng-container matColumnDef="nb_hours">
                            <th mat-header-cell *matHeaderCellDef> {{'nb_hours' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.nb_hours}} </td>
                        </ng-container>
                        <ng-container matColumnDef="groups">
                            <th mat-header-cell *matHeaderCellDef> {{'groups' | translate}} </th>
                            <td mat-cell *matCellDef="let row"> {{row.groups}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>

                <div *ngIf="reportOther.length > 0">
                    <div class="sem-title sem-break">Autres</div>
                    <div class="mat-elevation-z8">
                        <table mat-table style="width:100%" [dataSource]="dataSourceOther">
                            <ng-container matColumnDef="subject">
                                <th mat-header-cell *matHeaderCellDef> {{'subject' | translate}} </th>
                                <td mat-cell *matCellDef="let row"> {{row.subject}} </td>
                            </ng-container>
                            <ng-container matColumnDef="teacher">
                                <th mat-header-cell *matHeaderCellDef> {{'teacher' | translate}} </th>
                                <td mat-cell *matCellDef="let row"> {{row.teacher}} </td>
                            </ng-container>
                            <ng-container matColumnDef="subject_type">
                                <th mat-header-cell *matHeaderCellDef> {{'subject_type' | translate}} </th>
                                <td mat-cell *matCellDef="let row"> {{row.subject_type}} </td>
                            </ng-container>
                            <ng-container matColumnDef="nb_hours">
                                <th mat-header-cell *matHeaderCellDef> {{'nb_hours' | translate}} </th>
                                <td mat-cell *matCellDef="let row"> {{row.nb_hours}} </td>
                            </ng-container>
                            <ng-container matColumnDef="groups">
                                <th mat-header-cell *matHeaderCellDef> {{'groups' | translate}} </th>
                                <td mat-cell *matCellDef="let row"> {{row.groups}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </div>
            </div>
            <ng-template #no_data>
                <div class="empty_frame">
                    <img src="assets/empty.png">
                </div>
            </ng-template>
        </mat-card-content>
    </mat-card>
</div>

